import React from "react";

interface LoadingIndicatorProps {
  text?: string;
  className?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  text = "loading...",
  className = "",
}) => {
  return (
    <div className={`fixed inset-0 flex items-center justify-center ${className}`}>
      <div className="px-3 py-1 text-xs font-medium leading-none text-center text-blue-800 bg-blue-200 rounded-full 
        animate-pulse dark:bg-blue-900 dark:text-blue-200">
        {text}
      </div>
    </div>
  );
};

export default LoadingIndicator;